import { render, staticRenderFns } from "./NominateMemberCreate.vue?vue&type=template&id=06c0b45c"
import script from "./NominateMemberCreate.vue?vue&type=script&lang=js"
export * from "./NominateMemberCreate.vue?vue&type=script&lang=js"
import style0 from "./NominateMemberCreate.vue?vue&type=style&index=0&id=06c0b45c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports